import type { SiteInfo } from '@/types/content';

export const siteInfo: SiteInfo = {
  name: '瓜田爆料',
  slogan: '分类合集 · 分区浏览 · 一站式吃瓜看料',
  tagline: '把热闹的娱乐话题，整理成看得懂的合集',
  description:
    '瓜田爆料是一个把娱乐圈、网红圈、素人话题与行业观察内容整理成分类合集的内容站点。我们不追逐标题党，而是按主题分类、按脉络整理，让你在分区浏览中快速找到真正感兴趣的话题类型。',
  email: 'hello@guatianbaoliao.com',
  workingHours: '工作日 10:00 - 19:00 处理来信',
  since: '2021',
};

export const siteNav = [
  { label: '首页', to: '/' },
  { label: '分类合集', to: '/#categories' },
  { label: '热门话题', to: '/#trending' },
  { label: '常见问题', to: '/#faq' },
  { label: '关于我们', to: '/about' },
];